import { render, staticRenderFns } from "./ReviewPlanCard.vue?vue&type=template&id=1ed9a341&scoped=true&"
import script from "./ReviewPlanCard.vue?vue&type=script&lang=js&"
export * from "./ReviewPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPlanCard.vue?vue&type=style&index=0&id=1ed9a341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9a341",
  null
  
)

export default component.exports